"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidPatternRegex = void 0;
class FluidPatternRegex {
}
exports.FluidPatternRegex = FluidPatternRegex;
FluidPatternRegex.EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
FluidPatternRegex.US_PHONE_NUMBER = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
FluidPatternRegex.ZIP_CODE = /^\d{5}(?:[-\s]\d{4})?$/;
FluidPatternRegex.UK_POST_CODE = /^[A-Z]{1,2}[0-9R][0-9A-Z]? [0-9][A-Z]{2}$/i;
FluidPatternRegex.STATE_CODE = /^[A-Z]{2}$/;
FluidPatternRegex.SSN = /^\d{3}-\d{2}-\d{4}$/;
FluidPatternRegex.DATE = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;
FluidPatternRegex.TIME_24H = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
FluidPatternRegex.TIME_12H = /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/;
FluidPatternRegex.URL = new RegExp("^" +
    // Protocol identifier
    "(?:(?:https?|ftp)://)" +
    // User:pass authentication
    "(?:\\S+(?::\\S*)?@)?" +
    "(?:" +
    // IP address exclusion
    // Private & local networks
    "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
    "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
    "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
    // IP address dotted notation octets
    // Excludes loopback network 0.0.0.0/8
    // Traffic routed for local network segments
    // Start of private addresses range
    "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
    "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
    "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
    "|" +
    // Hostname
    "(?:(?:[a-z0-9]+-?[a-z0-9]+)*\\.)+" +
    // TLD identifier
    "(?:[a-z]{2,}\\.?)" +
    ")" +
    // Port number
    "(?::\\d{2,5})?" +
    // Resource path
    "(?:/[^\\s]*)?" +
    "$", "i");
FluidPatternRegex.CREDIT_CARD = /^(\d{4}-){3}\d{4}$/;
FluidPatternRegex.ALPHA_NUMERIC = /^[a-z0-9]+$/i;
FluidPatternRegex.PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/;
FluidPatternRegex.INTEGER = /^\d+$/;
FluidPatternRegex.FLOAT = /^[-+]?[0-9]*\.?[0-9]+$/;
FluidPatternRegex.HEX_COLOR = /^#([0-9a-fA-F]{3}){1,2}$/;
FluidPatternRegex.HTML_TAG = /^<([a-z]+)([^<]+)*(?:>(.*)<\/\1>|\s+\/>)$/;
FluidPatternRegex.USERNAME = /^[a-zA-Z0-9_-]{3,16}$/;
FluidPatternRegex.HASHTAG = /(?:^|\s)(?:#)([a-zA-Z\d]+)/gm;
